export const daysOfWeek: Record<string, { label: string; prefix: string }> = {
  MONDAY: { label: 'Monday', prefix: 'Mon' },
  TUESDAY: { label: 'Tuesday', prefix: 'Tue' },
  WEDNESDAY: { label: 'Wednesday', prefix: 'Wed' },
  THURSDAY: { label: 'Thursday', prefix: 'Thu' },
  FRIDAY: { label: 'Friday', prefix: 'Fri' },
  SATURDAY: { label: 'Saturday', prefix: 'Sat' },
  SUNDAY: { label: 'Sunday', prefix: 'Sun' },
};
